export * from './simple-layout.component';



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/containers/simple-layout/index.ts